import { render, staticRenderFns } from "./AlumniForm.vue?vue&type=template&id=214c3ddf&"
import script from "./AlumniForm.vue?vue&type=script&lang=js&"
export * from "./AlumniForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports